import { render, staticRenderFns } from "./m-error.vue?vue&type=template&id=6c9516f4&scoped=true&"
import script from "./m-error.vue?vue&type=script&lang=js&"
export * from "./m-error.vue?vue&type=script&lang=js&"
import style0 from "./m-error.vue?vue&type=style&index=0&id=6c9516f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9516f4",
  null
  
)

export default component.exports